import {
  MFA_SETUP,
  SOFTWARE_TOKEN_MFA,
  MFA_AUTH_CHOOSE_FACTOR,
  MFA_WEB_AUTHN_SETUP,
  MFA_REGISTER_CHOOSE_FACTOR,
  WEB_AUTHN_MFA,
  mfaFactor,
} from 'constants/authentication'

export const getButtonLabel = (
  mfaType,
  challenge,
  fields,
  showMFARegisterOption
) => {
  if (
    challenge === MFA_REGISTER_CHOOSE_FACTOR ||
    challenge === MFA_WEB_AUTHN_SETUP ||
    (challenge === WEB_AUTHN_MFA && fields.webAuthnName !== '') ||
    showMFARegisterOption === mfaFactor.webAuthN
  ) {
    return 'Register'
  }

  if (challenge === SOFTWARE_TOKEN_MFA || challenge === MFA_SETUP) {
    return 'Submit'
  }

  if (
    challenge === MFA_AUTH_CHOOSE_FACTOR ||
    mfaType === 'OTP' ||
    (challenge === WEB_AUTHN_MFA && fields.webAuthnName === '')
  ) {
    return 'Authenticate'
  }
}

export const getMfaHeadertitle = (
  mfaType,
  challenge,
  fields,
  showMFARegisterOption
) => {
  if (
    challenge === MFA_REGISTER_CHOOSE_FACTOR ||
    challenge === MFA_WEB_AUTHN_SETUP ||
    (challenge === WEB_AUTHN_MFA && fields.webAuthnName !== '') ||
    showMFARegisterOption === mfaFactor.webAuthN
  ) {
    return 'Setup MFA Device'
  }

  if (challenge === SOFTWARE_TOKEN_MFA || challenge === MFA_SETUP) {
    return 'Login to you Account'
  }

  if (
    challenge === MFA_AUTH_CHOOSE_FACTOR ||
    mfaType === 'OTP' ||
    (challenge === WEB_AUTHN_MFA && fields.webAuthnName === '')
  ) {
    return 'Select Authentication Option'
  }
}
